import uScopeInternal from './uscope';
import viewerInternal from './viewer';
import './accordion';
import './slide-tray';
import './vil';
// /////////////////////////////////////////////////////////
// Incapacitate IA for eSM 12.5 as stated in story S-13873
// import './image-analysis';
// /////////////////////////////////////////////////////////
import './uscope-extensions';

export const viewer = viewerInternal;
export const uScope = uScopeInternal;

export default {
  viewer,
  uScope
};



// WEBPACK FOOTER //
// ./src/lib/index.js